<div class="flex-fill d-flex flex-column content-block dx-card p-3">
    <div class="d-flex flex-fill flex-column">
        <dx-data-grid
            #dataGrid
            keyExpr="id"
            class="flex-fill d-flex flex-column"
            height="100px"
            [dataSource]="customerRates"
            [showBorders]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="rowDoubleClick($event)"
            (onCellClick)="onRateUpdatesCellClick($event)"
        >
            <dxi-data-grid-column dataField="id" width="100" alignment="left"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="customerId" width="100" cellTemplate="linkTemplate"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="customer.displayName"
                caption="Customer Name"
                width="175"
                cellTemplate="linkTemplate"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="customer.type.name" caption="Customer Type" width="125"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="customer.hasUniqueRates"
                caption="Has Unique Rates"
                width="125"
                dataType="boolean"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="rateType.name" caption="Rate Type" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="dumpsterId" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="dumpster.size" width="100" caption="Dumpster Size"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="rate" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="baseMileage" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="mileageOffset" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="mileageOffsetRate"
                [format]="{ type: 'currency', precision: 2 }"
                width="100"
            ></dxi-data-grid-column>
            <dxi-data-grid-column dataField="displayOrder" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="extendedRange" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="outerRange" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="regularRange" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="weightLimit" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="range" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="pricePerTon" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column dataField="zone" width="100"></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="lastUpdate"
                caption="Last Update"
                dataType="date"
                format="MM/dd/yy"
                width="100"
            ></dxi-data-grid-column>
            <dxi-data-grid-column
                dataField="rateUpdatesHtml"
                caption="Rate Updates"
                width="380"
                [encodeHtml]="false"
                [allowSorting]="false"
                [allowExporting]="false"
            >
            </dxi-data-grid-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                @if (cell.data) {
                    <a [routerLink]="[]" (click)="open(cell.data.customer)">{{ cell.text }}</a>
                }
            </div>

            <dxo-data-grid-selection mode="multiple"></dxo-data-grid-selection>
            <dxo-data-grid-search-panel [visible]="true"></dxo-data-grid-search-panel>
            <dxo-data-grid-filter-row [visible]="true"></dxo-data-grid-filter-row>
            <dxo-data-grid-export [enabled]="true" [allowExportSelectedData]="true"></dxo-data-grid-export>
            <dxo-data-grid-state-storing
                [enabled]="true"
                type="localStorage"
                storageKey="customer-rates-search-grid"
            ></dxo-data-grid-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'" class="d-flex align-items-center">
                <button
                    class="btn btn-primary me-1 mb-2"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0].customer)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                <dx-date-box class="me-1 mb-2 ms-4" style="width: 150px" [(value)]="jobSinceDate" placeholder="Job Since Date">
                </dx-date-box>
                <button class="btn btn-secondary me-1 mb-2" (click)="search()">Search</button>
            </div>
            <div *dxTemplate="let data of 'rateIncreaseButtons'" class="d-flex align-items-center">
                <dx-number-box
                    class="me-1 mb-2"
                    style="width: 120px"
                    [(value)]="rateIncreaseAmount"
                    [format]="{ type: 'currency', precision: 2 }"
                    placeholder="Amount"
                >
                </dx-number-box>
                <dx-date-box class="me-1 mb-2" style="width: 150px" [(value)]="rateIncreaseDate" placeholder="Increase Date"> </dx-date-box>
                <button
                    class="btn btn-success me-1 mb-2"
                    (click)="applyRateIncrease()"
                    [disabled]="rateIncreaseAmount == null || !rateIncreaseDate || dataGrid.instance.getSelectedRowsData().length === 0"
                >
                    Apply Rate Increase to Selected Rates
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
                <span class="me-3"
                    ><strong>{{ dataGrid.instance.getSelectedRowsData().length + ' selected' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
